import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey2, grey10, spacing8 } from "@churchofjesuschrist/eden-style-constants";
const Container = styled.div.withConfig({
  componentId: "sc-1q1g3h9-0"
})(["align-self:flex-end;position:sticky;bottom:0;background-color:", ";padding:", ";width:100%;border-block-start:1px solid ", ";z-index:2;"], grey2, spacing8, grey10);

const PanelFooter = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, props, children);
};

PanelFooter.propTypes = {
  /** Content inside the panel footer */
  children: PropTypes.node.isRequired
};
export default PanelFooter;